<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogTemporaryer" persistent max-width="650px">
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span class="ra-head-text-bold pa-1" style="color: black;">เพิ่มผู้รักษาการ</span>
        <!-- <UpdateTitleOrgchart titlename="เพิ่มผู้อนุมัติ" style="text-decoration: underline;" :btnDel="false" /> -->
      </v-card-title>
      <v-card-text>
        <v-row class="align-center" justify="start">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <span class="ra-head-text" style="">เลือกผู้รักษาการ</span>
          </v-col>
          <div class="">
            <v-radio-group
              v-model="radios"
              row
              >
              <v-radio
                class="radio-border"
                label="ตนเอง"
                value="ตนเอง"
              ></v-radio>
              <v-radio
                class="radio-border"
                label="ค้นหาจากรหัสพนักงาน"
                value="ค้นหาจากรหัสพนักงาน"
              ></v-radio>
              <!-- <v-radio
                class="radio-border"
                label="ค้นหาจาก One ID"
                value="ค้นหาจาก One ID"
              ></v-radio> -->
            </v-radio-group>
          </div>
        </v-row>
        <v-row v-if="radios === 'ค้นหาจากรหัสพนักงาน'">
          <v-col cols="12">
            <v-autocomplete
              v-model="dataSearchEmployee"
              @change="searchEmployee(dataSearchEmployee)"
              :items="itemUser"
              item-text="dataShow"
              item-value="employeeId"
              :search-input.sync="searchEmpoyee"
              outlined
              dense
              class="mt-2"
              placeholder="ค้นหา พนักงาน"
              no-data-text="ไม่พบข้อมูล"
            >
              <template v-slot:append>
                <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @change="searchFilterData(), page=1">
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="pl-3 mb-2">
          <span>ผลการค้นหา</span>
        </v-row>
        <div class="pa-3" style="background-color: #F8F9FB; height: 270px;">
          <v-avatar
            v-if="searchEmpoyee !== null || employeeIdDefault !==''"
            class="mt-1 ml-2"
            size="80"
            rounded
            style="float: left;"
            >
            <v-img
              class="card-header-userimg-border"
              cover
              :lazy-src="require('@/assets/icons/no_user.png')"
              :src="failed_image ? require('@/assets/icons/no_user.png') : img"
              :alt="employeeId"
              v-on:error="onImgError()"
              aspect-ratio="1"
              height="100%"
            />
          </v-avatar>
          <v-row v-if="searchEmpoyee !== null || employeeIdDefault !==''" class="pl-2 pr-5 mb-5 align-center">
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">รหัสพนักงาน</p>
              <span class="txt-font" style="color: #333;">{{employeeId}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">ชื่อ-สกุล</p>
              <span class="txt-font" style="color: #333;">{{fNameTh}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">ตำแหน่ง</p>
              <span class="txt-font" style="color: #333;">{{position}}</span>
            </v-col>
            <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">อีเมล</p>
              <span class="txt-font" style="color: #333;">{{email}}</span>
            </v-col>
            <!-- <v-col cols="8" class="form-control">
              <p class="txt-font" style="margin-top: 0%;">บริษัท</p>
              <span class="txt-font" style="color: #333;">{{companyName}}</span>
            </v-col> -->
            <!-- <v-spacer></v-spacer>
            <v-col cols="2" sm="12" md="2" lg="2" class="pa-0">
              <v-btn
                color="red" dark
                class="create-orgchart-header-cancel-btn pa-3"
                @click="clearSearchEmployee()"
                >
                  ล้างข้อมูล
                <v-icon right dark>fa-times</v-icon>
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row v-else class="pl-3" justify="center">
            <span class="ra-head-text mt-15">ไม่มีข้อมูล</span>
          </v-row>
        </div>
        <v-row v-if="radios !== null">
          <div class="">
            <p class="txt-font" style="margin-top: 5%;">หนังสือมอบอำนาจช่วง</p>
            <v-radio-group
              v-model="radiosTemporary"
              row
              >
              <v-radio
                class="radio-border"
                label="มอบอำนาจ"
                value="มอบอำนาจ"
              ></v-radio>
              <v-radio
                class="radio-border"
                label="มอบอำนาจช่วง"
                value="มอบอำนาจช่วง"
              ></v-radio>
            </v-radio-group>
          </div>
          <v-col cols="5" sm="5" md="5" lg="5" class="pt-3 pb-0" v-if="radiosTemporary === 'มอบอำนาจช่วง'">
            <span class="ra-span-text">ระยะเวลารักษาการ</span>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="mt-2"
                  v-model="dateRangeTextCreate"
                  placeholder="วว/ดด/ปปปป - วว/ดด/ปปปป"
                  readonly
                  append-icon="fa-calendar-alt"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  @change="searchFilterData()"
                >
                <template v-slot:append>
                  <img width="20" height="20" src="@/assets/icons/today.png" >
                </template>
                </v-text-field>
              </template>
              <v-date-picker v-model="datesCreateAt" range @change="datesCreateAtRun()"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row v-if="radiosTemporary !== null">
          <v-col cols="8">
            <p class="txt-font" style="margin-top: 0%;">เลขที่หนังสือมอบอำนาจ</p>
            <v-text-field
              v-model="poaNo"
              label="เลขที่หนังสือมอบอำนาจ"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <p class="txt-font" style="margin-top: 0%;">หนังสือมอบอำนาจช่วง</p>
            <div class="box-image3 mt-0">
            <v-row>
              <v-col cols="7">
                <span v-if="filesPoa.length === 0" class="text-right ml-5" style="color: #999999; font-size: 12px; margin-top: 0%;">อัปโหลดหนังสือมอบอำนาจ</span>
                <input type="file" id="files" hidden ref="PickfilesPoa" multiple v-on:change="onFileSelected('poa')"/>
                <div v-for="(file, key) in filesPoa" :name="file.name" class="file-listing ml-1 mt-0" :key="key">
                  <span class="mb-5" close :id="key" :name="file.name" @click:close="removeFile(key, 'poa')" color=""><strong class="txt-font">{{ file.name }}</strong>&nbsp;</span>
                </div>
              </v-col>
              <v-col cols="2">
                <v-btn
                  id="btnbrowse"
                  name="btnbrowse"
                  depressed
                  color="#EFF4FD"
                  class="ml-5 mb-0"
                  small
                  style="margin-top: -10px; margin-right: -20%;"
                  v-on:click="addFiles('poa')"
                  readOnly
                >
                <span class="txt-font ml-3" style="color: #3776E9;">เลือกไฟล์</span>
                </v-btn>
              </v-col>
            </v-row>
            </div>
            <v-progress-linear
              v-show="loadingFile === true"
              indeterminate
              color="cyan darken-0"
            ></v-progress-linear>
            <p class="txt-font" style="margin-top: 5%;">อัปโหลดได้เฉพาะไฟล์ .pdf เท่านั้น</p>
          </v-col>
        </v-row>
        <!-- <FullLoading :loading="loadingUsers"></FullLoading> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="button-color-outline" outlined @click="closeDialog()">ยกเลิก</v-btn>
        <!-- <v-btn v-if="type === 'approver'" class="ra-button1" color="#1654C6" dark @click="confirmApprove()">เพิ่มผู้ดูแล</v-btn> -->
        <v-btn v-if="poaNo === '' || filesPoa.length === 0" width="20%" class="pl-3 pr-3" color="grey" depressed disabled>เพิ่มผู้รักษาการ</v-btn>
        <v-btn v-else class="button-color" dark @click="confirmApprove()">เพิ่มผู้รักษาการ</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import { getUserByKeyword, searchSelectEmployee, hostImageUrlv3 } from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'

export default {
  name: 'dialog-create-approver',
  components: {
    // FullLoading,
    // UpdateTitleOrgchart
    OverlayLoading
  },
  data () {
    return {
      isLoading: false,
      loadingFile: false,
      loading: false,
      loadingUsers: true,
      dialogTemporaryer: false,
      failed_image: false,
      radios: null,
      menu: false,
      radiosTemporary: null,
      employeeIdDefault: '',
      propsEmpId: '',
      serviceType: '',
      serviceName: '',
      note: '',
      formId: '',
      senderName: '',
      dataCreate: '',
      chkRole: 'admin',
      fNameTh: '',
      lNameTh: '',
      email: '',
      approveType: 'ผู้อนุมัติ',
      companyName: '',
      companyId: '',
      img: '',
      employeeId: '',
      id: '',
      position: '',
      userImg: '',
      dataSearchEmployee: '',
      action: '',
      type: '',
      index: '',
      items: [],
      itemUser: [],
      filesPoa: [],
      filesPoaName: [],
      filesPoaBase64: [],
      Base64: [],
      datesCreateAt: [],
      poaNo: '',
      search: null,
      select: null,
      searchEmpoyee: null,
      rulesSearch: [
        v => !!v || 'กรุณากรอก Username หรือ E-mail'
      ],
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
        // v => v.length <= 10 || 'Name must be less than 10 characters'
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('openDialogTemporaryer')
  },
  async mounted () {
    await EventBus.$on('openDialogTemporaryer', this.openDialogAddAprover)
  },
  computed: {
    dateRangeTextCreate () {
      return this.datesCreateAt.join(' ~ ')
    }
  },
  watch: {
    radios (val) {
      if (val === 'ตนเอง') {
        this.img = ''
        this.employeeIdDefault = ''
        this.employeeIdDefault = this.$store.state.user.employeeId
        this.searchEmployee(this.$store.state.user.employeeId)
      } else if (val === 'ค้นหาจากรหัสพนักงาน') {
        this.failed_image = false
        // this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.companyId = ''
        // this.getUser()
      } else if (val === 'ค้นหาจาก One ID') {
        this.failed_image = false
        this.dataSearchEmployee = ''
        this.employeeIdDefault = ''
        this.img = ''
        this.id = ''
        this.fNameTh = ''
        this.employeeId = ''
        this.position = ''
        this.email = ''
        this.companyName = ''
        this.companyId = ''
        // this.searchEmployeeOne()
      }
    },
    datesCreateAt: function (val) {
      // this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
        // this.searchFilterData()
      }
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    // this.getUser()
  },
  methods: {
    datesCreateAtRun () {
      this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
    },
    onImgError () {
      this.failed_image = true
    },
    async openDialogAddAprover (value, item, action, index, type) {
      // console.log('item', item)
      // console.log('Data Dialog add approver :', value, type, item, action, index)
      this.loading = true
      this.searchEmpoyee = ''
      this.employeeIdDefault = ''
      this.dataSearchEmployee = ''
      // this.img = ''
      this.radios = null
      this.action = action
      this.index = index
      this.type = type
      this.filesPoa = []
      this.filesPoaName = []
      this.filesPoaBase64 = []
      this.Base64 = []
      this.datesCreateAt = []
      this.poaNo = ''
      this.dataSearchEmployee = item.employeeId
      this.getUser()
      // this.dialogTemporaryer = value
      if (this.action === 'edit') {
        this.radios = 'ค้นหาจากรหัสพนักงาน'
        this.searchEmpoyee = item.employeeId
        this.searchEmployee(item.employeeId)
        // this.radiosTemporary = item.type
        if (item.start !== '' && item.end !== '') {
          this.radiosTemporary = 'มอบอำนาจช่วง'
        } else {
          this.radiosTemporary = item.type
        }
        this.filesPoa.push({
          name: item.name
        })
        this.filesPoaName = item.name
        // this.filesPoaBase64 = []
        this.createAt = item.date
        this.datesCreateAt[0] = item.startDate
        this.datesCreateAt[1] = item.endDate
        this.datesCreateAtRun()
        this.dateRangeTextCreate = item.date
        this.poaNo = item.poaNo
      } else if (this.action === 'add') {
        // console.log('add')
        this.img = ''
        // this.onImgError
      }
    },
    closeDialog () {
      this.clearSearchEmployee()
      this.dialogTemporaryer = false
      this.searchEmpoyee = ''
      this.employeeIdDefault = ''
      this.dataSearchEmployee = ''
      this.img = ''
      this.radios = null
      this.radiosTemporary = null
      this.action = ''
      this.index = ''
      this.type = ''
      this.filesPoa = []
      this.filesPoaName = []
      this.filesPoaBase64 = []
      this.Base64 = []
      this.datesCreateAt = []
      this.poaNo = ''
      // this.onImgError()
      // this.failed_image = false
    },
    clearSearchEmployee () {
      this.loadingUsers = true
      this.radios = null
      this.dataSearchEmployee = ''
      this.searchEmpoyee = ''
      this.fNameTh = ''
      this.lNameTh = ''
      this.employeeId = ''
      this.position = ''
      this.email = ''
      // this.img = ''
      this.id = ''
      this.companyName = ''
      this.loadingUsers = false
    },
    async getUser () {
      // this.loading = true
      this.loadingUsers = true
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          if (res.result.length) {
            res.result.map((el, index) => {
              if (el.userImg === '') {
                el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
              } else {
                el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
              }
              temp.push({
                no: index + 1,
                dataShow: el.employeeId + ' - ' + el.name,
                ...el
              })
            })
          }
          // temp = res.result
          this.itemUser = temp
          this.loading = false
          this.dialogTemporaryer = true
          // this.dataSearchEmployee = temp[0].employeeId
          // this.fNameTh = temp[0].fNameTh
          // this.email = temp[0].email
          // this.position = temp[0].positionName.position
          // this.img = temp[0].userImg
        }
      } catch (error) {
        console.log(error)
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    async searchEmployee (value) {
      // this.loading = true
      // this.loadingUsers = true
      const obj = {
        search: value
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        // console.log('Res add approver', res)
        if (res.result[0]) {
          this.id = res.result[0]._id
          this.fNameTh = res.result[0].name
          this.employeeId = res.result[0].employeeId
          this.position = res.result[0].position.positionName
          this.email = res.result[0].emailOneId
          this.img = res.result[0].userImg
          this.companyName = res.result[0].companyName
          this.companyId = res.result[0].companyId
          if (this.img === '') {
            this.img = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
          } else {
            this.img = `${hostImageUrlv3}/${res.result[0].userImg}/${res.result[0].emailOneId}`
          }
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    async searchEmployeeOne () {
      // this.loading = true
      // this.loadingUsers = true
      const obj = {
        search: 'sittikorn0993'
      }
      try {
        const res = await searchSelectEmployee(obj, this.$store.state.token)
        // console.log('Res add approver One', res)
        if (res.result[0]) {
          this.id = res.result[0]._id
          this.fNameTh = res.result[0].name
          this.employeeId = res.result[0].employeeId
          this.position = res.result[0].position.positionName
          this.email = res.result[0].email
          this.img = res.result[0].userImg
          this.companyName = res.result[0].companyName
          this.companyId = res.result[0].companyId
          if (this.img === '') {
            this.img = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
          } else {
            this.img = `${hostImageUrlv3}/${res.result[0].userImg}/${res.result[0].emailOneId}`
          }
        } else {
          this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
      }
    },
    confirmApprove () {
      if (this.dataSearchEmployee === '' || this.employeeId === '') {
        swal('คำเตือน', 'กรุณากรอกรหัสพนักงานที่ต้องการค้นหา', 'warning', {
          button: false,
          timer: 2000
        })
      } else {
        // มอบอำนาจ
        // undefined undefined
        if (this.radiosTemporary === 'มอบอำนาจช่วง' && this.createAt === undefined) {
          swal('คำเตือน', 'กรุณาเลือกวันที่มอบอำนาจช่วงให้ครบ', 'warning', {
            button: true
          })
        } else {
          var valueList = {
            id: this.id,
            name: this.fNameTh,
            employeeId: this.employeeId,
            nickname: '',
            position: this.position,
            email: this.email,
            approveType: this.approveType,
            companyId: this.companyId,
            userImg: this.img,
            fileName: this.filesPoaName,
            file: this.filesPoaBase64,
            poaNo: this.poaNo,
            // date: this.createAt === 'undefined undefined' ? '-' : this.createAt,
            // start: this.datesCreateAt[0] === undefined ? '' : this.datesCreateAt[0],
            // end: this.datesCreateAt[1] === undefined ? '' : this.datesCreateAt[1],
            date: this.radiosTemporary === 'มอบอำนาจ' ? '' : this.createAt,
            start: this.datesCreateAt[0] === undefined ? '' : this.datesCreateAt[0],
            end: this.datesCreateAt[1] === undefined ? '' : this.datesCreateAt[1],
            type: this.radiosTemporary
          }
          // console.log('result add', valueList)
          EventBus.$emit('addAprover', valueList, this.index, this.action, this.type)
          this.type = ''
          this.dialogTemporaryer = false
          this.fNameTh = ''
          this.lNameTh = ''
          this.employeeId = ''
          this.position = ''
          this.email = ''
          this.companyName = ''
          // this.img = ''
          this.radiosTemporary = null
          this.poaNo = ''
          this.filesPoa = []
          // this.onImgError()
          // swal('Success', 'โอนย้ายสิทธิ์ สำเร็จ', 'success')
        }
      }
    },
    addFiles (type) {
      // console.log('add type', type)
      if (type === 'certificate') {
        this.$refs.PickfilesCertificate.click()
      } else if (type === 'poa') {
        this.$refs.PickfilesPoa.click()
      }
    },
    onFileSelected (type) {
      this.loadingFile = true
      this.filesPoa = []
      var uploadedFilesPoa = this.$refs.PickfilesPoa.files
      this.filesPoaName = uploadedFilesPoa[0].name
      for (let i = 0; i < uploadedFilesPoa.length; i++) {
        var dotindexPoa = uploadedFilesPoa[i].name.lastIndexOf('.')
        var FileExtensionPoa = uploadedFilesPoa[i].name.substr(dotindexPoa + 1).toLowerCase()

        if (FileExtensionPoa === 'pdf') {
          this.filesPoa.push(uploadedFilesPoa[i])
          setTimeout(() => {
            this.loadingFile = false
          }, 2000)
        } else {
          swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesPoa[i].name.substr(-4)}`, 'warning')
          this.loadingFile = false
        }
      }
      if (window.File && window.FileReader && window.FileList && window.Blob) {
        document.getElementById('files').addEventListener('change', this.handleFileSelect(this.filesPoa), false)
      } else {
        alert('The File APIs are not fully supported in this browser.')
      }
    },
    handleFileSelect (evt) {
      var f = evt[0] // FileList object
      var reader = new FileReader()
      // Closure to capture the file information.
      reader.onload = (function (f) {
        return function (e) {
          var binaryData = e.target.result
          var base64String = window.btoa(binaryData)
          this.base64 = base64String
          // document.getElementById('base64').value = base64String
          // alert('File converted to base64 successfuly!\nCheck in Textarea')
        }
      })(f)
      this.filesPoaBase64 = reader
      // Read in the image file as a data URL.
      reader.readAsBinaryString(f)
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
